import { connect } from 'react-redux'
import { getState, getDispatch } from 'x/modules/productlist/ProductListViewConnect'
import { getMkpChannels } from 'x/redux/selectors'
import ProductListViewXSellyToMkpMapping from './ProductListViewXSellyToMkpMapping'

export default connect(
  (state) => ({
    ...getState(state),
    mkpChannels: getMkpChannels(state),
  }),
  (dispatch) => getDispatch(dispatch)
)(ProductListViewXSellyToMkpMapping)
